import { createContext, ReactNode, useContext } from "react";
import { EditorNodeType } from "../nodes";


export interface SelectedNode {
  id: string;
  type: EditorNodeType;
  data: unknown;
}

interface NodeSelectionContextType {
  selected: SelectedNode | null;
  clearSelection: () => void;
  setSelected: (selected: SelectedNode | null) => void;
}

const NodeSelectionContext = createContext<NodeSelectionContextType | null>(null);

export function SelectionProvider({
  children,
  selected,
  setSelected,
  onClearSelection,
}: {
  children: ReactNode;
  selected: SelectedNode | null;
  setSelected: (selected: SelectedNode | null) => void;
  onClearSelection: () => void;
}) {
  return (
    <NodeSelectionContext.Provider value={{ selected, clearSelection: onClearSelection, setSelected }}>
      {children}
    </NodeSelectionContext.Provider>
  );
}

export function useNodeSelection() {
  const context = useContext(NodeSelectionContext);
  if (!context) {
    throw new Error("useSelection must be used within SelectionProvider");
  }
  return context;
}

export function useIsNodeSelected(nodeId?: string): boolean {
  const { selected } = useNodeSelection();

  if (!nodeId) return false;

  return selected?.id === nodeId;
}
